import { Component } from '@angular/core';
import { TenantService } from '../services/tenant.service';
import { Title } from '@angular/platform-browser';
import * as Globals from '../../globals';
import { ActivatedRoute, Router } from '@angular/router';
import { PageviewsettingsService } from '../services/pageviewsettings.service';
import { AbstractControl, NgForm } from '@angular/forms';
import { GiveawayService } from '../services/giveaway.service';

@Component({
  selector: 'app-giveaway-page1',
  templateUrl: './giveaway-page1.component.html',
  styleUrls: ['./giveaway-page1.component.css']
})
export class GiveawayPage1Component {
	giveaway: GiveawayService;
	tenantId: any;
	affiliateId: any;
	loadeddata: any;
	giveawayTermsUrl:any;
	formData = {
	name: '',
	email: '',
	state: '',
	phone: '',
	agree: false
  };
tenant: TenantService;
title:Title
  states = [
    'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California',
    'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia'
    
  ];
iconsWithLabels: { icon: string; label: string }[] = [];

	constructor(
			private titleService: Title,
			private tenantService: TenantService,
			private route: ActivatedRoute,
			private router: Router,
			private settingsService: PageviewsettingsService,
			private giveawayService: GiveawayService			
	) {
		this.title = this.titleService;
		this.tenant = this.tenantService;
		this.giveaway = this.giveawayService;
	}

	ngOnInit() {
		let collegeName = this.route.snapshot.paramMap.get('collegemobile') || '/defaultpage';

		this.settingsService.getCollegetenantcode(collegeName).subscribe((data: { result: { id: string; affiliateId: any; }; }) => {
			this.tenantId = parseInt(data.result.id)
			this.affiliateId = data.result.affiliateId
			this.loadPageSettings()
		});

		var guid = this.route.snapshot.paramMap.get('guid')?.toString();
		this.giveaway.get(guid).subscribe(data => {
			var endDate = new Date(data['result']['endDateTime'] + "Z");
			this.giveawayTermsUrl = data['result']['termsUrl'];
			var now = new Date();
			if (now >= endDate) {
				this.router.navigate([this.tenantService.getName(), 'giveaway-closed']);
			}
		});
	}

	loadPageSettings() {
		this.settingsService.getPageViewSettings(this.affiliateId, this.tenantId).subscribe(data => {
			this.loadeddata = data.result;
		});

		this.iconsWithLabels = this.tenant.getTenantIconItems();
	}

	filterPhone(event: KeyboardEvent) {
		return !Number.isNaN(Number(event.key));
	}


	submitForm(form: NgForm) {
		console.log("this.formData.state: " + this.formData.state);
		this.formData.name = this.formData.name?.trim();
		this.formData.phone = this.formData.phone?.trim();

		const guid = this.route.snapshot.paramMap.get('guid');
		if (!this.formData.name || !this.formData.email 
				|| !this.formData.phone || !this.formData.agree.valueOf()
				|| this.formData.state == '' || this.formData.phone.length < 10) {
			for (var controlKeys in form.controls) {
				const control = form.controls[controlKeys];
				control.markAsTouched();
			}
			return;
		}

		// regex validation 
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		if (!emailRegex.test(this.formData.email)) {
			console.log('Invalid email format');
			return;
		}

		const phoneRegex = /^[0-9]*$/;
		if (this.formData.phone && !phoneRegex.test(this.formData.phone)) {
			console.log('Invalid phone number');
			return;
		}

		console.log('Submitting to API:', this.formData);
		this.settingsService.creategiveawayentry(guid, this.formData)
			.subscribe({
			next: (response) => {
				console.log('endpoint called success', response);
		
			this.router.navigate(
			[this.tenant.getName() + '/giveawayconfirmation'],
				{ state: { status: 'success', message: 'Your entry has been submitted successfully!' }}
			);
		},
		error: (error) => {
			console.error('Error calling endpoint', error.error?.resultCode?.message);
			this.router.navigate(
				[this.tenant.getName() + '/giveawayconfirmation'],
				{ state: { status: 'error', message: error.error?.resultCode?.message || 'Something went wrong. Please try again.' } }
				);
			}
		});

	}
}
